'use client';

import { useRouter } from 'next/navigation';
import NormalButton from '@/components/Button/normal';

export default function NotFoundClient() {
  const router = useRouter();
  return (
    <NormalButton onClick={() => router.push('/')} className="w-48">
      Back to Home
    </NormalButton>
  );
}
